import { render, staticRenderFns } from "./templateDetails.vue?vue&type=template&id=b7f47fc6&scoped=true&"
import script from "./templateDetails.vue?vue&type=script&lang=js&"
export * from "./templateDetails.vue?vue&type=script&lang=js&"
import style0 from "./templateDetails.vue?vue&type=style&index=0&id=b7f47fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f47fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7f47fc6')) {
      api.createRecord('b7f47fc6', component.options)
    } else {
      api.reload('b7f47fc6', component.options)
    }
    module.hot.accept("./templateDetails.vue?vue&type=template&id=b7f47fc6&scoped=true&", function () {
      api.rerender('b7f47fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mail/components/templateDetails.vue"
export default component.exports